"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackHeaderSearchBar_exports = {};
__export(StackHeaderSearchBar_exports, {
  StackHeaderSearchBar: () => StackHeaderSearchBar,
  appendStackHeaderSearchBarPropsToOptions: () => appendStackHeaderSearchBarPropsToOptions
});
module.exports = __toCommonJS(StackHeaderSearchBar_exports);
var import_children = require("../../headless/children");
function StackHeaderSearchBar(_props) {
  return null;
}
Object.assign(StackHeaderSearchBar, {
  [import_children.NAVIGATOR_CONFIG]: true
});
function appendStackHeaderSearchBarPropsToOptions(options, props) {
  return {
    ...options,
    headerSearchBarOptions: props
  };
}
//# sourceMappingURL=StackHeaderSearchBar.js.map
